module.exports = __webpack_public_path__ + "static/img/gf.5bfe74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gf.png
// module id = xhiH
// module chunks = 1